module.exports = __webpack_public_path__ + "static/media/guidance-bg.8a761721.svg";